import { flushSync } from 'react-dom';

export const communityTransitionName = (id: string) => `community-${Array.from(id).map(char => char.charCodeAt(0).toString(16)).join('-')}`;
type TransitionDocument = Document & { startViewTransition?: (update: () => void) => { finished: Promise<void>; skipTransition: () => void } };
let active: { skipTransition: () => void } | undefined;

// Shared community identities survive the route change. The browser interpolates
// their measured bounds instead of zooming an outgoing screen and replacing it.
export function travelUniverse(update: () => void) {
  const documentWithTransitions = document as TransitionDocument;
  active?.skipTransition();
  if (!documentWithTransitions.startViewTransition || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { update(); return; }
  const transition = documentWithTransitions.startViewTransition(() => flushSync(update));
  active = transition;
  void transition.finished.catch(() => {}).finally(() => { if (active === transition) active = undefined; });
}
